import React from 'react'
import './StartNow.css'
import {Link} from 'react-router-dom'

function StartNow() {
  return (
    <Link to='/register'>
        <div className='start-now'>Start Now</div>
    </Link>
  )
}

export default StartNow